export default {
      id: "arrowForward-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#arrowForward-usage",
      toString: function () {
        return this.url;
      }
    }